import { render, staticRenderFns } from "./InHole.vue?vue&type=template&id=aefced72&scoped=true&"
import script from "./InHole.vue?vue&type=script&lang=js&"
export * from "./InHole.vue?vue&type=script&lang=js&"
import style0 from "./InHole.vue?vue&type=style&index=0&id=aefced72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefced72",
  null
  
)

export default component.exports